import Api from "~/service/Api";

class CreditCardTransactionRepository {
  fetchOne(creditCardTransactionId) {
    return Api.get(`/credit/card-transactions/${creditCardTransactionId}`);
  }
}

export default CreditCardTransactionRepository;
